import { collectionList } from "@/mocks/homeData";
import type { CollectionItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function CollectionGrid() {
  return (
    <section id="collections" className="w-full px-4 py-20 md:px-8 md:py-28">
      <SectionHeading
        kicker="黑料网红合集"
        title="按主题打包，一次看完整条脉络"
        desc="黑料网红合集把同一主题下的零散节点收拢到一起，按年度、直播、回应、
          资料等角度分区，点进来就能顺着顺序读完，不用再来回跳转。"
      />

      <div className="mt-10 h-44 w-full overflow-hidden rounded-lg border border-background-200 md:h-56">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20abstract%20warm%20beige%20paper%20texture%20with%20faint%20ink%20strokes%20and%20soft%20folded%20shadows%2C%20muted%20red%20and%20gold%20tone%2C%20minimal%20editorial%20backdrop%2C%20soft%20diffused%20light%2C%20high%20detail&width=1400&height=700&seq=hlwh-coll-01&orientation=landscape"
          alt="黑料网红合集 专区氛围配图"
          className="h-full w-full object-top"
        />
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {collectionList.map((item: CollectionItem) => (
          <article
            key={item.title}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 font-label text-[11px] text-primary-700">
                <i className="ri-stack-line" />
                {item.tag}
              </span>
              <span className="inline-flex items-center gap-1 font-label text-[11px] text-foreground-500">
                <i className="ri-list-check" />
                {item.count} 条
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-3 flex-1 text-[13px] leading-relaxed text-foreground-600">
              {item.desc}
            </p>
            <span className="mt-6 inline-flex cursor-pointer items-center gap-1.5 font-label text-xs text-primary-600">
              查看合集
              <i className="ri-arrow-right-line" />
            </span>
          </article>
        ))}
      </div>
    </section>
  );
}